import { render, staticRenderFns } from "./OrganismAddServiceData.vue?vue&type=template&id=270a0ae6&scoped=true&"
import script from "./OrganismAddServiceData.vue?vue&type=script&lang=js&"
export * from "./OrganismAddServiceData.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAddServiceData.vue?vue&type=style&index=0&id=270a0ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a0ae6",
  null
  
)

export default component.exports